import { FC, useEffect, useState } from 'react';

import './styles/root.scss';
import 'antd/dist/antd.css';
import { bindAnalytics, unbindAnalytics } from '../helpers/utils/analytics';
import { getAccessToken } from '../helpers/utils/auth';
import { bindClickObserver } from '../helpers/utils/hits';
import { clearSiteHandoffMark, finishSiteHandoff, hasSiteHandoff } from '../helpers/utils/siteHandoff';
import { AppRouter } from './providers/router/ui/AppRouter';
import HelpModeWrapper from '../shared/common/components/help-mode/HelpModeWrapper';
import Loader from '../shared/common/components/loader/Loader';
import { ModalProvider } from '../shared/common/components/reports/dashboards/ContextModal';
import GlobalErrorWrapper from '../shared/common/components/wrappers/global-error-wrapper/GlobalErrorWrapper';
import GlobalModalsWrapper from '../shared/common/components/wrappers/modal-wrapper/GlobalModals';
import { useActions } from '../shared/common/hooks/useActions';


const App: FC = () => {
    const { setIsAuth } = useActions();

    /**
     * Человек вошёл в окне на продающем сайте и пришёл сюда с меткой в адресе.
     * Пропуск остался на том домене, поэтому получаем свой — по корешку сессии
     * из куки. Пока идёт проверка, держим экран загрузки: иначе на долю секунды
     * мелькнёт страница входа, хотя пароль уже введён.
     */
    const [ isSiteHandoff, setIsSiteHandoff ] = useState(
        () => hasSiteHandoff() && !getAccessToken()
    );

    useEffect(() => {
        let cancelled = false;

        if (isSiteHandoff) {
            finishSiteHandoff().then((isEntered) => {
                if (cancelled) return;

                if (isEntered) setIsAuth(true);
                setIsSiteHandoff(false);
            });
        } else if (hasSiteHandoff()) {
            // Человек уже вошёл раньше — поднимать нечего, просто убираем метку
            clearSiteHandoffMark();
        }

        return () => { cancelled = true; };
    }, []);

    useEffect(() => {
        bindClickObserver();
        bindAnalytics();

        return () => unbindAnalytics();
    }, []);

    // Ctrl+Shift+K — очистка кеша для решения конфликтов между версиями фронта
    useEffect(() => {
        const handleClearCache = (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.code === 'KeyK') {
                e.preventDefault();
                localStorage.clear();
                sessionStorage.clear();
                window.location.reload();
            }
        };
        window.addEventListener('keydown', handleClearCache);
        return () => window.removeEventListener('keydown', handleClearCache);
    }, []);

    if (isSiteHandoff) {
        return (
            <div id="app" className="App">
                <Loader loading hasTip fullHeight />
            </div>
        );
    }

    return (
        <div id="app" className="App">
            <HelpModeWrapper>
                <ModalProvider>
                    <GlobalErrorWrapper>
                        <GlobalModalsWrapper>
                            <AppRouter />
                        </GlobalModalsWrapper>
                    </GlobalErrorWrapper>
                </ModalProvider>
            </HelpModeWrapper>
        </div>
    );
};

export default App;
